import { Box, Typography, Divider } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import EMPChip from "../EMPChip/EMPChip";

const getItemPadding = ({ isFirstItem, twoByTwo, index }) => {
  if (isFirstItem) {
    return {
      xs: "16px 0px 16px 16px",
      sm: "16px 0px 16px 16px",
      md: "16px 0px 16px 16px",
    };
  }

  if (twoByTwo) {
    return {
      xs: "16px 0px 16px 16px",
      sm: "16px 0px 16px 16px",
      md: "16px 0px 16px 16px",
    };
  }

  if (!twoByTwo && index !== 0) {
    return {
      xs: "16px",
      sm: "16px",
      md: "16px 16px 16px 0px",
    };
  }

  return {
    xs: "16px",
    sm: "16px",
    md: "16px",
  };
};

const EMPDataCard = ({
  data = [],
  hasBackground = false,
  twoByTwo = false,
  testId,
}) => {
  const spanValue = twoByTwo
    ? { xs: "span 6" }
    : { xs: "span 6", sm: "span 6", md: "span 2" };

  const columnValue = data.length > 3 ? 12 : 6;

  return (
    <Box sx={{ height: "100%" }}>
      <Box
        sx={{
          border: hasBackground ? "none" : "1px solid #B2B2B2",
          borderRadius: 2,
          background: hasBackground
            ? "linear-gradient(135deg, #F5F6F7 0%, #FFFFFF 100%)"
            : "transparent",
          height: "inherit",
          padding: hasBackground ? "8px 56px" : 0,
        }}
        display="grid"
        gridTemplateColumns={`repeat(${columnValue}, 1fr)`}
        columnGap={4}
        rowGap={0}
        data-testid={testId}
      >
        {data.map((item, index) => {
          const isFirstItem = index === 0 || index === 6;

          return (
            <React.Fragment key={item.heading}>
              <Box
                gridColumn={spanValue}
                sx={{
                  padding: getItemPadding({
                    isFirstItem,
                    twoByTwo,
                    index,
                  }),
                }}
              >
                <Typography variant="caption">{item.heading}</Typography>

                {item.highlight ? (
                  <Box>
                    <EMPChip label={item.content} labelColor={item.color} />
                  </Box>
                ) : (
                  <Typography variant={hasBackground ? "body1" : "body2"}>
                    {item.content}
                  </Typography>
                )}
              </Box>

              {twoByTwo
                ? (index + 1) % 2 === 0 &&
                  index + 1 < data.length && (
                    <Divider
                      sx={{ gridColumn: `span ${columnValue}`, my: 0 }}
                    />
                  )
                : (index + 1) % 6 === 0 &&
                  index + 1 < data.length && (
                    <Divider
                      sx={{ gridColumn: `span ${columnValue}`, my: 0 }}
                    />
                  )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

EMPDataCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.node,
      content: PropTypes.node,
      highlight: PropTypes.bool,
      color: PropTypes.oneOf([
        "default",
        "primary",
        "secondary",
        "error",
        "info",
        "success",
        "warning",
      ]),
    })
  ),
  hasBackground: PropTypes.bool,
  twoByTwo: PropTypes.bool,
  testId: PropTypes.string,
};

export default EMPDataCard;
